import { ContextCurrencyFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"

export const ContextBalanceFragment = graphql(
  `
    fragment ContextBalance on Balance {
      id
      currency {
        id
        contractAddress
        chain {
          identifier
          minOfferPriceUsd
          arch
        }
        usdPrice
        symbol
        imageUrl
        name
        decimals
        chainIdentifier
        ...ContextCurrency
      }
      quantity
      usdValue
    }
  `,
  [ContextCurrencyFragment],
)
